import React, { useEffect, useState } from "react";
import {
  createStyles,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import useInfiniteScroll from "react-infinite-scroll-hook";
import IPagination from "../../core/contracts/IPagination";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "height": "100%",

      // "& .MuiTableRow-root:nth-child(odd)": {
      //   background: theme.customPaper.background.cardBackgroundTable,
      // },

      "& .MuiTableCell-alignCenter": {
        color: theme.palette.text.primary,
      },

      "& .MuiTableCell-stickyHeader": {
        backgroundColor: "#1D212A",
        color: theme.palette.common.white,
      },
    },
  })
);

type PaginateTableProps = {
  header: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[][];
  loadMoreItems: () => {};
  loading?: boolean;
  pagination: IPagination;
};

const loadingState = new Array(12).fill({});

function PaginateTable({ header, rows, loading = false, loadMoreItems, pagination }: PaginateTableProps) {
  const classes = useStyles();

  const [loadingItems, setLoadingItems] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);

  const onLoadMore = async () => {
    setLoadingItems(true);
    const result = await loadMoreItems();
    if (result) {
      setLoadingItems(false);
    }
  };

  useEffect(() => {
    if (rows.length > 0) {
      setHasNextPage(pagination.CurrentPage < pagination.TotalPages);
    }
  }, [pagination])

  const infiniteRef = useInfiniteScroll({
    loading: loadingItems,
    hasNextPage,
    onLoadMore,
    scrollContainer: "window",
  });

  return (
    <TableContainer className={classes.root} component={Paper}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {header.map((h, idx) => (
              <TableCell align="center" key={`header_${idx}`}>
                <strong>{h}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody ref={infiniteRef as React.RefObject<HTMLTableSectionElement>}>
          {!loading &&
            rows.map((row, idx) => (
              <TableRow key={`row_${idx}`}>
                {row.map((cell, idy) => (
                  <TableCell align="center" key={`row_${idx}_col_${idy}`}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}

          {loading &&
            loadingState.map((_, idx) => (
              <TableRow key={`loading_row_${idx}`}>
                <TableCell colSpan={header.length}>
                  <Skeleton />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PaginateTable;
